import { Text } from 'shared/ui/common/Text'
import { WarningCard } from 'shared/ui/common/WarningCard'
import { Button } from 'shared/ui/controls/Button'

import { ReactComponent as ArrowSVG } from 'assets/arrow-side.svg'

import s from './FormDepositWarning.module.scss'

export const FormDepositWarning = () => {
  return (
    <WarningCard
      title="Important note:"
      content={
        <>
          <Text color="secondary" weight={400} size={12} isCentered>
            Note that due to the nature of the under-collateralized loans,
            deposits can incur negative interest rates in case borrowers do not
            repay. Please make sure you fully understand the risks before
            depositing:
          </Text>
          <a
            href="https://blog.roci.fi/how-lenders-can-earn-with-rocifi-4593611de16b"
            target="_blank"
            rel="noreferrer"
            className={s.link}
          >
            <Text tag="span" size={14}>
              READ
            </Text>
            <Button size={24} fashion="glass-matte" isSquare>
              <ArrowSVG />
            </Button>
          </a>
        </>
      }
    />
  )
}
